import {Siparis} from './siparis';

export class SiparislerPage {

  currentPage: number;
  pageCount: number;
  pageSize: number;
  rowCount: number;
  firstRowOnPage: number;
  lastRowOnPage: number;
  private pResults: Siparis[];
  isSiparis: boolean;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

  public get results(): Siparis[] {
    return this.pResults;
  }

  public set results(list: Siparis[]) {
    if (list != null) {
      this.pResults = list.map(t => new Siparis(t));
    }
  }

}
